import { createFileRoute, redirect } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'
import { NotificationManager } from '@/components/notifications/notification-manager'
import { PageHeader } from '@/components/page-header'

export const Route = createFileRoute('/_panel/powiadomienia')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'superadmin') {
      throw redirect({ to: '/' })
    }
  },
  component: NotificationManagerPage,
})

function NotificationManagerPage() {
  return (
    <>
      <PageHeader title="Menedżer powiadomień" />
      <NotificationManager />
    </>
  )
}
